import request from '@/utils/request'

// 获取过磅列表
export function upload(file, filename) {
  const data = new FormData();
  data.append('file', file, filename)
  return request.post('/ext/oss/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
